/**
 * Created by Jerker Nord on 2019-01-14.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {StickyWild} from "../../symbols/StickyWild";
import {ThorReelSymbol} from "../../symbols/ThorReelSymbol";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";

export class ThorReelWildsView extends BaseView {

    private static WILD_LIGHTNING_OFFSET_XPOS:number = 1;
    private static WILD_LIGHTNING_OFFSET_YPOS:number = -2;
    private static REEL_WILD_SPINE_ASSET_NAME:string = "lightningReel";
    private static CHAIN_WILD_SPINE_ASSET_NAME:string = "chainCD";
    private static REEL_WILD_ANIMATION_NAME:string = "Reel";
    private static WILD_CHAIN_ANIMATION_NAME:string = "WildChainCD";

    private static BONUS_LIGTNING_SOUNDS:string[] = [ThorSoundConfig.instance.BONUS_LIGHTNING_01, ThorSoundConfig.instance.BONUS_LIGHTNING_02];

    private _currentBonusLightningSound:number = 0;
    private _wildChainAnimationTop:PIXI.spine.Spine;
    private _wildChainAnimationCenter:PIXI.spine.Spine;
    private _wildChainAnimationBottom:PIXI.spine.Spine;

    private _layer:ScalableLayer;
    private _allOverlayWilds:StickyWild[];
    private _thorLightningAnimation:PIXI.spine.Spine;
    private _newWildsAdded:boolean = false;
    private _addNewWildsTL:TimelineLite;
    private _removeTL = new TimelineLite();

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._allOverlayWilds = [];
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.WILD_OVERLAY.name);
    }

    protected initAnimations():void {
        this._thorLightningAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorReelWildsView.REEL_WILD_SPINE_ASSET_NAME));
        this._thorLightningAnimation.alpha = 0;
        this.addChild(this._thorLightningAnimation);

        this._wildChainAnimationTop = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorReelWildsView.CHAIN_WILD_SPINE_ASSET_NAME));
        this._wildChainAnimationTop.alpha = 0;
        this.addChild(this._wildChainAnimationTop);

        this._wildChainAnimationCenter = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorReelWildsView.CHAIN_WILD_SPINE_ASSET_NAME));
        this._wildChainAnimationCenter.alpha = 0;
        this.addChild(this._wildChainAnimationCenter);

        this._wildChainAnimationBottom = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorReelWildsView.CHAIN_WILD_SPINE_ASSET_NAME));
        this._wildChainAnimationBottom.alpha = 0;
        this.addChild(this._wildChainAnimationBottom);

        this._layer.addChild(this);
    }

    public abort(newWilds:boolean[][]):void {
        if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
            this._addNewWildsTL.pause();
            this._addNewWildsTL.kill();
        }

        if(this._newWildsAdded == false) {
            for(let i:number = 0; i < newWilds.length; i++) {
                for(let j:number = 0; j < newWilds[i].length; j++) {
                    if(newWilds[i][j]) {
                        const originalSymbol:StateReelSymbol = Reels.getSymbol(i, j)!;
                        const stickyWild:StickyWild = new StickyWild(originalSymbol.symName, new PIXI.Point(i, j));
                        stickyWild.position.x = Helper.getSymbolPositions(i, j)[0];
                        stickyWild.position.y = Helper.getSymbolPositions(i, j)[1];
                        this._allOverlayWilds.push(stickyWild);
                        this.addChildAt(stickyWild, 0);
                    }
                }
            }
        }

        //Making sure previously added Wilds are visible
        for(let k:number = 0; k < this._allOverlayWilds.length; k++) {
            this._allOverlayWilds[k].alpha = 1;
        }

        this._newWildsAdded = false;
        this._wildChainAnimationTop.alpha = 0;
        this._wildChainAnimationCenter.alpha = 0;
        this._wildChainAnimationBottom.alpha = 0;
        this._thorLightningAnimation.alpha = 0;
    }


    private createLightningToStickyWildTL(position:[number, number]):TimelineLite {
        const lightningToStickyWildTL:TimelineLite = new TimelineLite();
        lightningToStickyWildTL.add((() => this._thorLightningAnimation.position.x = position[0] + ThorReelWildsView.WILD_LIGHTNING_OFFSET_XPOS));
        lightningToStickyWildTL.add((() => this._thorLightningAnimation.position.y = position[1] + ThorReelWildsView.WILD_LIGHTNING_OFFSET_YPOS));
        lightningToStickyWildTL.add(() => this._wildChainAnimationTop.position.x = position[0]);
        lightningToStickyWildTL.add(() => this._wildChainAnimationTop.position.y = (position[1] - (ThorGameConfig.instance.SYMBOL_HEIGHT + ThorGameConfig.instance.SYMBOL_BOTTOM_PADDING)));
        lightningToStickyWildTL.add(() => this._wildChainAnimationCenter.position.x = position[0]);
        lightningToStickyWildTL.add(() => this._wildChainAnimationCenter.position.y = position[1]);
        lightningToStickyWildTL.add(() => this._wildChainAnimationBottom.position.x = position[0]);
        lightningToStickyWildTL.add(() => this._wildChainAnimationBottom.position.y = (position[1] + (ThorGameConfig.instance.SYMBOL_HEIGHT + ThorGameConfig.instance.SYMBOL_BOTTOM_PADDING)));
        lightningToStickyWildTL.add(() => this._thorLightningAnimation.alpha = 1);
        lightningToStickyWildTL.add([
            () => this.playBonusLightningSound(),
            new SpineTween(this._thorLightningAnimation, 0, ThorReelWildsView.REEL_WILD_ANIMATION_NAME, 0)
        ]);
        lightningToStickyWildTL.add(() => this._thorLightningAnimation.alpha = 0);
        lightningToStickyWildTL.add(() => this._wildChainAnimationTop.alpha = 1);
        lightningToStickyWildTL.add(() => this._wildChainAnimationCenter.alpha = 1);
        lightningToStickyWildTL.add(() => this._wildChainAnimationBottom.alpha = 1);
        lightningToStickyWildTL.add([
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_CHAINS),
            new SpineTween(this._wildChainAnimationTop, 0, ThorReelWildsView.WILD_CHAIN_ANIMATION_NAME, 0), "-=0.2",
            new SpineTween(this._wildChainAnimationCenter, 0, ThorReelWildsView.WILD_CHAIN_ANIMATION_NAME, 0), "-=0.2",
            new SpineTween(this._wildChainAnimationBottom, 0, ThorReelWildsView.WILD_CHAIN_ANIMATION_NAME, 0), "-=0.2"
        ]);
        lightningToStickyWildTL.add(() => this._wildChainAnimationTop.alpha = 0);
        lightningToStickyWildTL.add(() => this._wildChainAnimationCenter.alpha = 0);
        lightningToStickyWildTL.add(() => this._wildChainAnimationBottom.alpha = 0);

        return lightningToStickyWildTL;
    }

    private playBonusLightningSound():void {
        if(this._currentBonusLightningSound == 0) {
            this._currentBonusLightningSound++;
        } else {
            this._currentBonusLightningSound--;
        }
        SlotGame.sound.playEffect(ThorReelWildsView.BONUS_LIGTNING_SOUNDS[this._currentBonusLightningSound]);
    }

    private getBonusSymbolPosition():PIXI.Point {
        let tempSymbol:ThorReelSymbol;
        let symbolPosition:[number, number];

        for(let i:number = 0; i < 4; i++) {
            tempSymbol = <ThorReelSymbol>Reels.getSymbol(4, i)!;
            if(tempSymbol.symName == "B") {
                symbolPosition = Helper.getSymbolPositions(4, i);
                break;
            }
        }

        return new PIXI.Point(symbolPosition![0], symbolPosition![1]);
    }

    public getAddNewWildsTL(newWilds:boolean[][]):TimelineLite {
        this._newWildsAdded = true;
        if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
            this._addNewWildsTL.pause();
            this._addNewWildsTL.kill();
        }
        this._addNewWildsTL = new TimelineLite();
        for(let i:number = 0; i < newWilds.length; i++) {
            for(let j:number = 0; j < newWilds[i].length; j++) {
                if(newWilds[i][j] == true) {
                    if(j == 1) {
                        const stickyWildTop:StickyWild = this.getStickyWild(i, j - 1);
                        this._allOverlayWilds.push(stickyWildTop);
                        const stickyWildMiddle:StickyWild = this.getStickyWild(i, j);
                        this._allOverlayWilds.push(stickyWildMiddle);
                        const stickyWildBottom:StickyWild = this.getStickyWild(i, j + 1);
                        this._allOverlayWilds.push(stickyWildBottom);
                        this._addNewWildsTL.add(this.createLightningToStickyWildTL(Helper.getSymbolPositions(i, j)));
                        this._addNewWildsTL.add(() => stickyWildTop.alpha = 1, "-=0.3");
                        this._addNewWildsTL.add(() => stickyWildMiddle.alpha = 1, "-=0.3");
                        this._addNewWildsTL.add(() => stickyWildBottom.alpha = 1, "-=0.3");
                        //addNewWildsTL.add(() => Reels.getSymbol(i, j)!.replaceWith("W", i));
                        //addNewWildsTL.add(() => Reels.getSymbol(i, j)!.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.sticky}));
                    }
                }
            }
        }
        return this._addNewWildsTL;
    }

    private getStickyWild(reel:number, position:number):StickyWild {
        const originalSymbol:StateReelSymbol = Reels.getSymbol(reel, position)!;
        const stickyWild:StickyWild = new StickyWild(originalSymbol.symName, new PIXI.Point(reel, position));
        stickyWild.position.x = Helper.getSymbolPositions(reel, position)[0];
        stickyWild.position.y = Helper.getSymbolPositions(reel, position)[1];
        stickyWild.alpha = 0;
        this.addChildAt(stickyWild, 0);
        return stickyWild;
    }

    /**
     * Show Wild and put original symbol back on reel behind Wild before spin starts.
     */
    public showAllWilds():void {
        let tempWild:StickyWild;
        for(let i:number = 0; i < this._allOverlayWilds.length; i++) {
            tempWild = this._allOverlayWilds[i];
            tempWild.visible = true;
            Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.replaceWith(tempWild.originalSymbolName, tempWild.originalReelPosition.x);
        }
    }

    public removeAllStickyWilds():void {
        while(this._allOverlayWilds.length > 0) {
            this.removeChild(this._allOverlayWilds.pop()!);
        }
    }

    public disableOverlayWilds():TimelineLite {
        if(this._removeTL && this._removeTL.isActive()) {
            this._removeTL.pause();
            this._removeTL.kill();
        }
        this._removeTL = new TimelineLite();
        this._removeTL.add(() => ThorGameModuleConfig.thorRandomWildsView.disableOverlayWilds());
        return this._removeTL;
    }

    public abortDisableOverlayWilds():void {
        if(this._removeTL && this._removeTL.isActive()) {
            this._removeTL.pause();
            this._removeTL.kill();
        }
        let tempWild:StickyWild;
        while(this._allOverlayWilds.length > 0) {
            tempWild = this._allOverlayWilds.pop()!;
            tempWild.originalSymbolName = Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.symName;
            Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.replaceWith("W", tempWild.originalReelPosition.x);
            this.removeChild(tempWild);
        }
    }

    get allOverlayWilds():StickyWild[] {
        return this._allOverlayWilds;
    }
}